import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LANGUAGE } from "@prequalification/models";
import { SupportedLocale } from "@rig/common";
import { CTATextComponent, IconButtonComponent } from "@rig/ng-buttons";
import { BoxContainerComponent, DividerComponent } from '@rig/ng-containers';
import { 
  CardArtComponent,
  IconComponent
} from "@rig/ng-media";
import { 
  ListComponent,
  ListItemComponent 
} from "@rig/ng-lists";
import { TextStyleDirective } from "@rig/ng-typography";
import { ToolTip, TooltipContent } from "@rig/ng-overlays";
import { Observable } from "rxjs";


@Component({
  selector: "pre-qualification",
  templateUrl: "./pre-qualification.component.html",
  styleUrls: ["./pre-qualification.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    BoxContainerComponent,
    CardArtComponent,
    ListComponent,
    ListItemComponent,
    TextStyleDirective,
    ToolTip,
    TooltipContent,
    DividerComponent,
    IconComponent,
    CTATextComponent,
    IconButtonComponent
  ]
})
export class PreQualificationComponent implements OnInit{
  @Input() cardName = "";
  @Input() productCode = "";
  @Input() submitted = false;
  @Input() locale: SupportedLocale = LANGUAGE.EN as SupportedLocale;
  @Input() isMobile$: Observable<boolean>;

  isPremiumCard = false;
  isWestJet = false;

  ngOnInit(): void {
      this.isPremiumCard = this.productCode === 'MCB' || this.productCode === 'AIB';
      this.isWestJet = this.productCode === 'MCB';
  }
  
  goToWestjetSignup() {
    if (this.locale === 'en') {
      window.open('https://www.westjet.com/en-ca/rewards/join');
    } else {
      window.open('https://www.westjet.com/fr-ca/rewards/join');
    }
  }

}

